<template>
  <div class='token_bg'>
    <div class='section_title'>{{$t("message.choose_token_type")}}</div>
    <div class='drop-down-list'>
      <select class='token_input' v-model='curSwapType' aria-invalid='false'>
        <option v-for='(token,i) in tokenList' v-bind:value='token.SwapType' :key="i">
          {{getToKenDescByType(token.SwapType)}}
        </option>
      </select>
      <div class='arrow-down'></div>
    </div>
    <!--token address desc-->
    <div class='section_title token_address_desc'>
      {{$t("message.enter_address")}}
    </div>
    <!--token address input-->
    <input type = 'text' autocomplete='off' autocorrect="off" autocapitalize="off" spellcheck="false" :placeholder='addressPlaceholder' class='token_address_input' v-model="addressValue" v-on:input="onSwapAddrChange">
    <!--exchange bnb memo-->
    <template v-if="isExChangeAddr">
      <div class="section_title token_address_desc">Enter your Exchange memo</div>
      <input type = 'text' autocomplete='off' autocorrect="off" autocapitalize="off" spellcheck="false" placeholder='' class='token_address_input' v-model="memoValue">
    </template>
    <!--swap fee desc-->
    <div v-if="isShowFeeTips" class='swap_fee_desc'>*{{swapFeeDesc}}</div>
    <div v-if="serviceFee > 0" class="fee_notice_wrap">
      <fee-notice
        :token="sourceToken"
        :fee="serviceFee"
      />
    </div>
  </div>
</template>

<script>
import utils from '../../common/v2/utils'
import feeNotice from './feeNotice.vue'
export default {
  name: 'tokenListView',
  components: { feeNotice },
  props: {
    tokenList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      curSwapType: -1, // current swap type
      addressValue: '',
      memoValue: '',
      isShowFeeTips: false,
      swapFeeDesc: '',
      isExChangeAddr: false
    }
  },
  computed: {
    serviceFee () {
      return utils.serviceFee(this.curSwapType)
    },
    sourceToken () {
      const key = utils.getSourceTokenKey(this.curSwapType)
      return key ? this.$t(key) : ''
    },
    addressPlaceholder () {
      return utils.getAddressPlaceholder(this.curSwapType)
    }
  },
  methods: {
    getToKenDescByType (swapType) {
      const key = utils.getSwapDescKey(swapType)
      return key ? this.$t(key) : ''
    },

    getSwapInfo () {
      return {
        swapType: this.curSwapType,
        address: this.addressValue,
        exChangeMemo: this.memoValue
      }
    },

    initData (val) {
      if (val.length > 0) {
        let fVal = val[0]
        let key = utils.swapTypeKey
        if (fVal.hasOwnProperty(key)) {
          this.curSwapType = fVal[key]
        }
      }
    },
    onSwapAddrChange () {
      let swapAddr = this.addressValue
      this.isExChangeAddr =
        (utils.checkIsBnbExchangeAddr(swapAddr) && utils.checkIsSwapToBep2(this.curSwapType)) ||
        (utils.checkIsCosMainNetExchangeAddr(swapAddr) && utils.checkIsSwapToCosMainNet(this.curSwapType))
    }

  },
  watch: {
    curSwapType (val) {
      this.addressValue = ''
      this.memoValue = ''
      this.swapFeeDesc = ''
      this.isShowFeeTips = false
      for (let token of this.tokenList) {
        if (token[utils.swapTypeKey] === val) {
          if (token.hasOwnProperty(utils.isFreeKey)) {
            let isFree = (token[utils.isFreeKey] === utils.SwapChargeStatus.SwapChargeStatusFree)
            if (!isFree) {
              this.isShowFeeTips = true
              if (token.hasOwnProperty(utils.feeDescKey)) {
                this.swapFeeDesc = token[utils.feeDescKey]
              }
            }
          }
          break
        }
      }
      this.isExChangeAddr = false
    },
    tokenList () {
      this.initData(this.tokenList)
    }
  },
  created () {
    this.initData(this.tokenList)
  }
}

</script>

<style scoped>
  .token_bg {
    width: 100%;
    max-width: 430px;
    display: flex;
    display: -ms-flex;
    flex-direction: column;
    justify-items: left;
    margin-bottom: 0;
    gap: 0;
  }

  .swap_fee_desc {
    margin-top: 8px;
    color: #991b1b;
    width: 100%;
    font-size: 12px;
    word-wrap: break-word;
    word-break: break-word;
  }

  .section_title {
    color: #18181b;
    font-weight: 600;
    width: 100%;
    font-size: 14px;
    word-wrap: break-word;
    word-break: break-word;
  }

  .drop-down-list {
    display: flex;
    display: -ms-flex;
    flex-direction: row;
    align-items: center;
  }
  .token_input {
    margin-top: 8px;
    width: 100%;
    height: 48px;
    border: 1px solid #e4e4e7;
    border-radius: 0;
    background-color: #fff;
    appearance:none;
    -moz-appearance:none;
    -webkit-appearance:none;
    padding: 0 40px 0 12px;
    box-sizing: border-box;
    color: #18181b;
    font-size: 14px;
    outline: none;
    transition: border-color 0.16s ease, box-shadow 0.16s ease;
  }

  .token_input:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.15);
  }

  .arrow-down {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #71717a;
    margin-left: -24px;
    margin-top: 8px;
    pointer-events: none;
  }

  .token_address_desc {
    margin-top: 20px;
  }

  .token_address_tips {
    color: rgb(220, 53, 69);
  }

  .token_address_input {
    margin-top: 8px;
    width: 100%;
    height: 48px;
    border-radius: 0;
    border: 1px solid #e4e4e7;
    background: #fff;
    outline: none;
    box-sizing: border-box;
    padding: 0 12px;
    font-size: 14px;
    color: #18181b;
    transition: border-color 0.16s ease, box-shadow 0.16s ease;
  }

  .token_address_input:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.15);
  }

  .fee_notice_wrap {
    width: 100%;
    box-sizing: border-box;
    margin-top: 20px;
  }

  @media (max-width: 768px) {
    .token_bg {
      width: 100%;
      max-width: none;
    }
  }

</style>
